module.exports = __webpack_public_path__ + "static/media/video.235f2e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Koombana/video.jpg
// module id = 296
// module chunks = 0